import * as RadixSwitch from '@radix-ui/react-switch';

interface Props {
  /** Whether the switch is checked */
  checked: boolean;
  /** Callback when the switch is checked */
  onCheckedChange: (checked: boolean) => void;
}

/**
 * Matcha styled generic switch component.
 */
export function Switch({ checked, onCheckedChange }: Props) {
  return (
    <RadixSwitch.Root
      className="w-8 h-4.5 bg-token-gray-600 rounded-full relative  shadow-[0_2px_10px_var(--black-a7)] webkit-tap-highlight-color-transparent data-[state=checked]:bg-token-purple-900"
      checked={checked}
      onCheckedChange={onCheckedChange}
    >
      <RadixSwitch.Thumb className="block w-3 h-3 bg-primitive-basic-white rounded-full shadow-[0_2px_2px_var(--black-a7)] translate-x-0.75 transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-4.25" />
    </RadixSwitch.Root>
  );
}
